import { React, useState, useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import plus from  "./img/plus.png";
import minus from  "./img/mins.jpg";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";
import right from  "./img/right.png";
import cross from  "./img/redcross.jpg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fileDownload from 'js-file-download';
import {VIEW_TIMEENTRY,APPROVAL_TIMEENTRY,SUBMIT_TIMEENTRY,GET_APPROVAL_TIMEENTRY,REJECT_TIMEENTRY,GET_MANAGERID,GET_VENDORMANAGERID,DOWNLOAD_TIMESHEET} from '../../Pages/AppConstant'

function Landing() {
    const [datearray,setDatearray]= useState("");
    const [requestdept,setRequestdept]= useState("");
    const [purpose,setPurpose]= useState("");
    const [asset_id,setAsset_id]= useState("");
    const [selectedproject,setSelectedproject] = useState("");
    const [ifchecked,setIfchecked] = useState(false);
    const [selectedtext,setSelectedtext] = useState("");
    const [selectdata, setSelectdata] = useState(undefined);
    const [fields, setFields] = useState([""]);
    const [fieldsremark, setFieldsremark] = useState([""]);    
    const [dateobjs, setDateobjs] = useState([""]);
    const [datelist, setDatelist] = useState([""]);
    const [formatdate, setFormatdate] = useState([""]);
    const [approvallist,setApprovallist]=useState([""]);
    const [istab,setIstab]=useState(2);
    const [monthselect,setMonthselect]=useState();
    const [monthselecttext,setMonthselecttext]=useState();
    const [yearselect,setYearselect]=useState();
    const [yearselecttext,setYearselecttext]=useState();
    const [monthdatas,setMonthdatas] = useState();
    const [checkedobj,setCheckedobj]= useState({});
    const [checkedobjarr,setCheckedobjarr]= useState([]);
    const [reportingmanager,setReportingmanager]=useState([])
    const [totalhoursworked,setTotalhoursworked]=useState("");
    const [previousenterval,setPreviousenterval]=useState("");
    const [selectedhouresval,setSelectedhouresval]=useState("");
    const [searchdata,setSearchdata]=useState([])
    const [savedApprovallist,setSavedApprovallist]=useState([])
	const [startdate,setStartdate]= useState("");
    const [enddate,setEnddate]= useState(""); 
	const [selecteddept,setSelecteddept]=useState("")										 
    
    useEffect(() => {
        callmanagerid();
        calldefaultfn();  
        getsession();    
        // fetchapprovaldata();
      }, []);

    useEffect(()=>{
        if(localStorage.getItem('type')!=="Offrole"){
            fetchapprovaldata();
        }       
        forloopfn();
    },[monthselect,yearselect])  


    const getsession=()=>{
        if(localStorage.getItem('sessions')!=="isactive"){
            window.location.href = "/"
        }
    }
    // const disableonpaste=()=>{
    //    const pasteBox document.getElementById("no-paste");
    //     pasteBox.onpaste = e => {
    //   e.preventDefault();
    //   return false;
    // }
    const calldefaultfn=()=>{
        const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const monvalue = ["31","29","31","30","31","30","31","31","30","31","30","31"];
        const d = new Date();
        let monthdata=monvalue[d.getMonth()];
        let name = month[d.getMonth()];
        let fullyear = (d.getFullYear()).toString();;
        setYearselect(fullyear)
        setMonthdatas(monthdata)
        let monthvalue;
        if((new Date().getMonth() +1)>9){
            monthvalue=new Date().getMonth()+1
        }else{
            monthvalue="0"+(new Date().getMonth() +1)
        }
        setMonthselect(monthvalue)
        setMonthselecttext(name)
        setSelecteddept(localStorage.getItem('dept'))    
        
    }
    const handleSubmit = (e) => {
        let excutefn=true;
        console.log(fields+dateobjs+datelist)
        let objlist={}
        let finalarray=[]
        let year;
        let month;
        let day;
        for(let i=0;i<=datelist.length;i++){
            if(datelist[i]!==undefined){
            year = new Date(datelist[i].date).getFullYear();
           
            if((new Date(datelist[i].date).getMonth()+1)<=9){
                month="0"+(new Date(datelist[i].date).getMonth()+1)
            }else{
                month= (new Date(datelist[i].date).getMonth()+1)
            }
            if( new Date(datelist[i].date).getDate()<=9){
                day= "0"+new Date(datelist[i].date).getDate()
            }else{
                day= new Date(datelist[i].date).getDate()
            }
        }
            
                objlist={
                    date:year+"-"+month+"-"+ day,
                    projectid:dateobjs[i],
                    hours:fields[i],
                    remarks:fieldsremark[i]===undefined?"":fieldsremark[i],
                    empid:localStorage.getItem('empid'),
                    emp_name:localStorage.getItem('empname'),
                    status:"Submitted",
                    month:monthselecttext,
                    year:yearselect,
                    rmid:reportingmanager
    
                }
            // }else{
            //     alert("Work Hours Should not be empty or less than working hours")
            //     excutefn=false
            //     break;
            // }
           
            if(objlist.projectid!==""&& objlist.projectid!==undefined && objlist.date!=="NaN-NaN-NaN"){
                if(objlist.hours!=="" && objlist.hours!==undefined){
                    finalarray.push(objlist)
                }else{
                    alert("Work Hours Should not be empty or less than Available hours")
                excutefn=false
                break;
                }
                
            }
            

        }
        if(excutefn===true){
            console.log(finalarray)
        if(finalarray.length>0){

            let newdata = {};
            let run =true;
            finalarray.forEach(function(d) {
              if (newdata.hasOwnProperty(d.date)) {
                newdata[d.date] = newdata[d.date] + parseInt(d.hours);
              } else {
                newdata[d.date] = parseInt(d.hours);
              }
            });
            
            var obj2 = [];
            
            for (var prop in newdata) {
              obj2.push({ date: prop, workhours: newdata[prop] });
            } 
            console.log(obj2)  
           
            for(var i=0; i<obj2.length; i++){  
                if(obj2[i].workhours<8){
                    run=false;
                    alert(" Please enter the full 8 hours of the day on " + obj2[i].date)
                    break;
                    
                }
            }
            if(run===true){
            insertfunction(finalarray);
                // alert("Sucesss")
            }
           
        }else{
            alert("Please Enter Value before Submit")
        }
       
        }
        
       

    };

    const insertfunction = (dates)=>{ 
   
    // const finalarray = [
    // ...new Map(
    //     dates.map(item => [
    //     `${item.hours}-${item.date}-${item.projectid}`,
    //     item
    //     ])
    // ).values()
    // ];
         const groupedData = dates.reduce((acc, item) => {
            if (!acc[item.date]) {
                acc[item.date] = [];
            }

            acc[item.date].push(item);
            return acc;
            }, {});

            const finalarray = [];

            Object.values(groupedData).forEach(records => {
            let totalHours = 0;

            records.forEach(record => {
                const hours = Number(record.hours);

                if (totalHours < 8) {
                finalarray.push(record);
                totalHours += hours;
                }
            });
            });
        axios.post(SUBMIT_TIMEENTRY, {finalarray})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
          setDatelist([""])
          forloopfn();
          callmanagerid();
          calldefaultfn();        
          fetchapprovaldata();
          

        })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const fetchapprovaldata = (data) =>{
        console.log(data)
        
        axios({
            method: 'get',
            url: GET_APPROVAL_TIMEENTRY,
            withCredentials: false,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
            params:{"empId" : localStorage.getItem('empid'),"month":monthselecttext,"year":yearselect}
          }).then(response => {
            // alert(response.data.data)
            let getdata=response.data.data
            // const getdatass = [
            // ...new Map(
            //     getdata.map(item => [
            //     `${item.hours}-${item.date}-${item.projectid}`,
            //     item
            //     ])
            // ).values()
            // ];
            const groupedData = getdata.reduce((acc, item) => {
            if (!acc[item.date]) {
                acc[item.date] = [];
            }

            acc[item.date].push(item);
            return acc;
            }, {});

            const result = [];

            Object.values(groupedData).forEach(records => {
            let totalHours = 0;

            records.forEach(record => {
                const hours = Number(record.hours);

                if (totalHours < 8) {
                result.push(record);
                totalHours += hours;
                }
            });
            });

            console.log(result);
            setApprovallist(result)
            setSavedApprovallist(result) 
            
                
        })
        .catch(error => {
            console.error(error);
        });
       
       
    }
    
    const gettotalhours=(e)=>{
        let newdata = {};
        e.forEach(function(d) {
            if (newdata.hasOwnProperty(d.date)) {
              newdata[d.date] = newdata[d.date] + parseInt(d.workedhours);
            } else {
              newdata[d.date] = parseInt(d.workedhours);
            }
          });
          
          var obj2 = [];
          
          for (var prop in newdata) {
            obj2.push({ date: prop, workhours: newdata[prop] });
          } 
          console.log(obj2)
          let totalhours=0
          for(var i=0; i<obj2.length; i++){  
            if(!isNaN(obj2[i].workhours)){
                totalhours+=obj2[i].workhours
                
            }
        }
        setTotalhoursworked(totalhours)
        console.log(totalhours)
    }
    const fetchAllData = (data) =>{
        console.log(data)
        axios({
            method: 'get',
            url: VIEW_TIMEENTRY,
            withCredentials: false,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
            params:{"empId" : localStorage.getItem('empid'),"month":monthselecttext,"year":yearselect}
          }).then(response => {
            // alert(response.data.data)
            
            // if(monthselecttext==="Jun"){
            //     getdata=response.data.data
            // }else{
            //     getdata=""
            // }
            let rawdatass;
            rawdatass=response.data.data  
        // const getdata = [
        // ...new Map(
        //     rawdatass.map(item => [
        //     `${item.hours}-${item.date}-${item.projectid}`,
        //     item
        //     ])
        // ).values()
        // ];

        // console.log(getdata);
             const groupedData = rawdatass.reduce((acc, item) => {
            if (!acc[item.date]) {
                acc[item.date] = [];
            }

            acc[item.date].push(item);
            return acc;
            }, {});

            const getdata = [];

            Object.values(groupedData).forEach(records => {
            let totalHours = 0;

            records.forEach(record => {
                const hours = Number(record.hours);

                if (totalHours < 8) {
                getdata.push(record);
                totalHours += hours;
                }
            });
            });
           
            let getdatearray=[]
            let getobjs={}
            for (let i = 0; i < getdata.length; i++) {
                // console.log(getdata[i].date.split("-").reverse().join("-"));
                let year;
                let month;
                let day;
                year = new Date(getdata[i].date).getFullYear();
                if((new Date(getdata[i].date).getMonth()+1)<=9){
                    month="0"+(new Date(getdata[i].date).getMonth()+1)
                }else{
                    month= (new Date(getdata[i].date).getMonth()+1)
                }
                if( new Date(getdata[i].date).getDate()<=9){
                    day= "0"+new Date(getdata[i].date).getDate()
                }else{
                    day= new Date(getdata[i].date).getDate()
                }
                console.log(day+"-"+monthselecttext+"-"+year)
                getobjs={
                    date:day+"-"+monthselecttext+"-"+year,
                    status:getdata[i].status,
                    projects:getdata[i].projectid,
                    workedhours:getdata[i].hours,
                    remarks:getdata[i].remarks
                    
                }
                getdatearray.push(getobjs)
            }
            console.log(getdatearray)
            console.log(data)
            let fulldata = data.map(item=>{
                const result= getdatearray.find(item1=>item1.date===item.date);
                return(result)?{...item,...result}:item;
                
            })
            console.log(fulldata)
            const array1 = [...getdatearray,...data]
            const map = new Map();
            array1.forEach(item=>{
                if(map.has(item.date)){
                    const list = map.get(item.date);
                    list.push(item)
                }else{
                    map.set(item.date,[item])
                }
            })
            const result= Array.from(map.values()).flatMap(arr=>(arr.length>1)?arr.filter((item)=>item.projects):arr)
            console.log(result)
            // console.log(data)
            // const fetchedval={}
            // for (let f of getdatearray) {
            //     fetchedval[f.date] = f.status;
            //  }
            // for (let s of data) {
            //     const status = fetchedval[s.date];
            //     if (status) s.status = status;
            //   }
            //   console.log(data);
            //     setDatearray([])
                sortbykey(result,"date")
                setDatearray(result) 
                gettotalhours(result);

        })
        .catch(error => {
            console.error(error);
        });
       
       
    }
    
    const callintervalfn=(data)=>{
        let setval=true
        if(setval ===true){
            setval=false
            setInterval(() => {
                setDatearray(data)           
            }, 1000);
        }
        
        
    }

    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    
     const handleReset = () => {
        // Reset all state variables here
        setRequestdept("");
        setPurpose("");
        setAsset_id("");
        setIfchecked(false)
        
    };
    const getUserData = ()=>{
       
        
       
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }

    const checkedval=(e,i)=>{
        if(e.currentTarget.checked===true){
            setIfchecked(true)
        }else{
            setIfchecked(false)
        }
       
    }
    const callselectedfn=(e,i)=>{
        setSelectedproject(e.target.value)
        setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    }

    const forloopfn=()=>{      
        let arraylist=[]
        let formattedate=[]
        let objs={}
        let newarray=[]
        var yearselecteddata=yearselect
        for (var i = 1; i <= monthdatas; ++i) {
            formattedate.push(yearselecteddata+"-"+monthselect+"-"+i)
            arraylist.push(i+"-"+monthselecttext+"-"+yearselecteddata)
            if(i<=9){
                objs={                
                    date: "0"+i+"-"+monthselecttext+"-"+yearselecteddata,
                    isreq:true,
                    workedhours:'',
                    projects:'',
                    status:"To be submitted"
                  }
            }else{
                objs={                
                    date: i+"-"+monthselecttext+"-"+yearselecteddata,
                    isreq:true,
                    workedhours:'',
                    projects:'',
                    status:"To be submitted"  
                  }
            }
            
            newarray.push(objs)
          }
          console.log(newarray)
          setFormatdate(formattedate)
          setDatearray(newarray)
          console.log(arraylist)
          fetchAllData(newarray);
    }
    const options = [
    "9m Std AC Seychelles ",
"9m Std AC WCL- Bhutan  (New) ",
"9m Std  AC Type II Staff ",
"9m STD AC BRTS ",
"9m STD Non-AC",
"9m STD AC WCL",
"9m ULE -  AGPL Spec",
"9m ULE – CESL Spec ",
"12m ULE- PM eDRIVE",
"5m Low Floor ",
"9m DD MV→TG ",
"12m Std Staff 184 kWh",
"IeV3+ ",
"IeV4+ ",
"E Dost Xpress ",
"P1",
"ADAS - Regulation (Bus)",
"ADAS - Regulation (LCV)",
"CALB battery - 12m ULE adopt",
"12m STD - BRTS",
"FAS|FPS | FDSS| AVAS : Regulation",
"AIS 216- Bus body Code- Regulation",
"Switch On",
"Field Issues",
"DC-DC Converter (Alternate Source)",
"Auto Expo",
"Pre - SPAC (2 - Bus; 2 - LCV)",
"Project Spark",
"QMS",
"PLM",
"Safety",
"Advance Technologies",
"Procurement & Stores",
"Others",
"Leave",
"Holiday"
    ];
    
    const onOptionChangeHandler = (i,event,val) => {
        setSelectdata(event.target.value);
        const datesval = [...dateobjs];
        const dateslistobj = [...datelist];
        datesval[i]=event.target.value
        dateobjs[i]= event.target.value
        dateslistobj[i] = val;
        dateobjs.push("");
        setDateobjs(dateobjs);
        datelist.push("")
        setDatelist(dateslistobj);

    };
    function handleChange(i, event,date) {
        const objval= [...datearray] 
        // objval[i].setvalue = event.target.value
        objval[i].workedhours = event.target.value
        const filtered = (col) => datearray.filter(i => i.date.includes(col));
        const output = filtered(date);
        console.log(output);
        let sumofval=0
        for (var q = 0; q <= output.length; ++q) {
            if(output[q]!==undefined){
            sumofval+= parseInt(output[q].workedhours) 
                  

        }
        }

        setSelectedhouresval(sumofval)
        // if(sumofval<9 ){
        //     if(!isNaN(sumofval)){
        //         // let selectedhours = totalhoursworked+parseInt(output[q].workedhours) 
        //         let selectedhours = totalhoursworked+parseInt(objval[i].workedhours)
        //         setPreviousenterval(parseInt(objval[i].workedhours) )
        //         setTotalhoursworked(selectedhours)
        //         }else{
        //             let selectedhours = totalhoursworked-previousenterval
        //             setTotalhoursworked(selectedhours)
        //             }
        // }else if(isNaN(sumofval)){
        //     let selectedhours = totalhoursworked-previousenterval
        //     setTotalhoursworked(selectedhours)
        //     } 
        if(sumofval>8 || sumofval===NaN){
            alert("Value should match the available working hours")
        }else{
            const values = [...fields];
            values[i] = event.target.value;
            values.push("");
            setFields(values);
           
            
        }
       
       
        
        console.log(sumofval)
        console.log(datearray)
       
        
      }
    const handleChangeremarks=(i, event,date)=>{
    const objval= [...datearray] 
        // objval[i].setvalue = event.target.value
        objval[i].remarks = event.target.value
        const filtered = (col) => datearray.filter(i => i.date.includes(col));
        const output = filtered(date);
        console.log(output);
        let sumofval=0
        for (var q = 0; q <= output.length; ++q) {
            if(output[q]!==undefined){
            sumofval+= parseInt(output[q].workedhours)          

        }
        }
        const values = [...fieldsremark];
        values[i] = event.target.value;
        values.push("");
        setFieldsremark(values);
        console.log(sumofval)
        console.log(datearray)
    }
    const addfield=(e,val)=>{
        const values= [...datearray]  
        let ojslist={
            date:values[val].date,isreq:false,status:"To be Submitted"
        }      
        values.push(ojslist)
        sortbykey(values,"date")
        console.log(values)
        // values.splice(val+1, 0, values[val]={date:values[val].date,isreq:false})
        setDatearray(values)

    }

    const sortbykey=(array,key)=>{
        return array.sort(function(a, b)
        {
         var x = a[key]; var y = b[key];
         return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
        console.log(array)
    }

    const removefield=(e,val)=>{
        let newarray=[];
        let newdatearray=[]
        let newdatobj=[]
        let newvalues=[];
        let newremarks=[];
        for (let i = 0; i < datearray.length; i++) {
            if(i!==val){
            newarray.push((datearray[i]))
            }
        } 
        for (let j = 0; j < datelist.length; j++) {
            if(j!==val){
                newdatearray.push((datelist[j]))
            }
        } 
        for (let k = 0; k < dateobjs.length; k++) {
            if(k!==val){
                newdatobj.push((dateobjs[k]))
            }
        }
        for (let m = 0; m < fields.length; m++) {
            if(m!==val){
                newvalues.push((fields[m]))
            }
        }
        for (let n = 0; n < fieldsremark.length; n++) {
            if(n!==val){
                newremarks.push((fieldsremark[n]))
            }
        }
        if(datearray[val].workedhours!==undefined){
            setTotalhoursworked(totalhoursworked-parseInt(datearray[val].workedhours))
        }   
       
        setFields(newvalues) 
        setFieldsremark(newremarks)    
        setDatelist(newdatearray)
        setDatearray(newarray)
        setDateobjs(newdatobj)
        console.log(newdatearray)
    }
    const enabletab=(e)=>{
         if(e===1){
            setIstab(2)
            callmanagerid();
        }else if(e===3){
            setIstab(3)
           
        }
            else{
            fetchapprovaldata();
            setIstab(1)
        }
    }

    const callmanagerid=()=>{
        if(localStorage.getItem('type')!=="Offrole"){
            if(localStorage.getItem('reporting_managerempid')!==""){
                setReportingmanager(localStorage.getItem('reporting_managerempid'))
            }else{
                alert("RM ID not exist") 
            }
        //     axios({
        //     method: 'get',
        //     url: GET_MANAGERID,
        //     withCredentials: false,
        //     headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
        //     params:{"empId" : localStorage.getItem('empid')}
        //   }).then(response => {
        //   //console.log("SuccessFully updated");
        //     if(response.data.data.length>0){
                
        //     }else{
        //         alert("RM ID not exist") 
        //     }
           

        // })
        //   .catch(function (error) {
        //     console.log(error);
        //   });
        }else{
            axios({
                method: 'get',
                url: GET_VENDORMANAGERID,
                withCredentials: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
                params:{"empId" : localStorage.getItem('empid')}
              }).then(response => {
              //console.log("SuccessFully updated");
                if(response.data.data.length>0){
                    setReportingmanager(response.data.data[0].manager_id)
                    localStorage.setItem('empname', response.data.data[0].employee_name);
                }else{
                   alert("RM ID not exist") 
                }
    
            })
              .catch(function (error) {
                console.log(error);
              });
            // setReportingmanager(localStorage.getItem('managerid'))
        }
    }
    const approvefn=()=>{

        axios.post(APPROVAL_TIMEENTRY, {checkedobjarr})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
          var ele=document.getElementsByName('chk');  
          for(var i=0; i<ele.length; i++){  
              if(ele[i].type=='checkbox') 
                  if(ele[i].checked===true) {
                     ele[i].checked=false;
                  }
                }
          fetchapprovaldata();         

        })
          .catch(function (error) {
            console.log(error);
          });
          
        // axios({
        //     method: 'get',
        //     url: APPROVAL_TIMEENTRY,
        //     withCredentials: false,
        //     headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
        //     params:{"id" : val.id}
        //   }).then(response => {
        //     // alert(response.data.data)
        //     let getdata=response.data.data
            
                
        // })
        // .catch(error => {
        //     console.error(error);
        // });
    }

    const rejectfn=(val,i)=>{

        axios.post(REJECT_TIMEENTRY, {checkedobjarr})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
          var ele=document.getElementsByName('chk');  
          for(var i=0; i<ele.length; i++){  
              if(ele[i].type=='checkbox') 
                  if(ele[i].checked===true) {
                     ele[i].checked=false;
                  }
                }
          fetchapprovaldata();         

        })
          .catch(function (error) {
            console.log(error);
          });
          
        // axios({
        //     method: 'get',
        //     url: REJECT_TIMEENTRY,
        //     withCredentials: false,
        //     headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
        //     params:{"id" : val.id}
        //   }).then(response => {
        //     // alert(response.data.data)
        //     let getdata=response.data.data
            
                
        // })
        // .catch(error => {
        //     console.error(error);
        // });
    }
    const callmonth=(e)=>{
        const monvalue = ["31","29","31","30","31","30","31","31","30","31","30","31"];
        let inte = parseInt(e.target.value)
        let monthdata=monvalue[inte-1];
        setMonthdatas(monthdata)
        setMonthselect(e.target.value)
        setMonthselecttext(e.target.options[e.target.selectedIndex].innerText)
        
        
    }
    const callyear=(e)=>{
        setYearselect(e.target.value)
        setYearselecttext(e.target.options[e.target.selectedIndex].innerText)
        
    }
    const checkedall=(e)=>{
        let array=[] 
        var ele=document.getElementsByName('chk');  
                for(var i=0; i<ele.length; i++){  
                    if(ele[i].type=='checkbox') 
                        if(ele[i].checked===true) {
                            array=[];
                            ele[i].checked=false;
                        }else{
                            console.log(approvallist)
                            let obj={}                                                      
                            obj.id = approvallist[i].id
                            array.push(obj)                           
                           
                            ele[i].checked=true;
                        }
                         
                } 
                setCheckedobjarr(array) 
    }

    const checkindividual=(e,val,i)=>{  
        if(e.currentTarget.checked===true){
            console.log(e,val,i)
            let checkedobjlist={}
            let arrayobj=[]
            checkedobjlist.id=val.id;
            setCheckedobj(checkedobjlist)        
            checkedobjarr.push(checkedobjlist)
            setCheckedobjarr(checkedobjarr)
            console.log(checkedobjarr)
        }else{
            let datavalues= checkedobjarr.filter(values => values.id !== val.id);
            setCheckedobjarr(datavalues)
            console.log(datavalues)
        }
        
    }
    const callapprove=()=>{
        if(checkedobjarr.length>0){
            approvefn()
        }else{
            alert("Please check box items to approve")
        }
        
    }
    
    const callreject=()=>{
        if(checkedobjarr.length>0){
            rejectfn()
        }else{
            alert("Please check box items to approve")
        }
        
    }
    const handleKeyDown = event => {
        if (event.keyCode === 189 ||event.keyCode === 190  ) {
            // alert();
          event.preventDefault();
        }
    }
    const searchfunction=(value)=>{
        setSearchdata(value)
        if(value!==''){
        let e = value.toLowerCase();
        let newarray = savedApprovallist.filter(function(val){
         if(val.empid.toLowerCase().includes(e)||val.emp_name.toLowerCase().includes(e) || val.projectid.toLowerCase().includes(e)||val.remarks.toLowerCase().includes(e)){
            var newobjs = {id:val.id,switch_code:val.switch_code,employee_name:val.employee_name}
            return newobjs
         }
        })
        setApprovallist(newarray)
        }
        else{
            setApprovallist(savedApprovallist)
        }
    }
    const generatereport=()=>{
        axios({
            method: 'get',
            url: DOWNLOAD_TIMESHEET,
            withCredentials: false,
            responseType: 'blob',
            params:{"start" :startdate,"end":enddate},
            headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
          }).then(response => {
            
            fileDownload(response.data, "Timesheet_"+new Date() +".xls");
      
            // OR you can save/write file locally.
            // fs.writeFileSync(outputFilename, response.data);
        })
        .catch(error => {
            console.error(error);
        });
    }
    return (
    <div className="bg_set_time">   
            <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
            </div><br/><br/>         
             <div>
            </div>
        <div>
            <div className=" ">
            <p className="Headings">Timesheet Entry</p>
            {localStorage.getItem('type')!=="Offrole" || localStorage.getItem('empid')=="BCS0008"? <div className="row tabdesigntm">
                <div className="col-md-5" style={{backgroundColor:"white"}}>
                    <div className="row">
            <div className={istab==2?"col-md-4 tabfirst-selected-time":"col-md-4 notselected-time"} onClick={()=>enabletab(1)}>Timesheet Entry</div>
            <div className={istab==1?"col-md-4 tabfirst-selected-time":"col-md-4 notselected-time"} onClick={()=>enabletab(2)}>Approval </div>
            {selecteddept==="SWITCH INFORMATION TECHNOLOGY" || selecteddept==="SWITCH HUMAN RESOUCES" || localStorage.getItem('empid')=="BCS0008"?<div className={istab==3?"col-md-3 tabfirst-selected-time":"col-md-3 notselected-time"} onClick={()=>enabletab(3)}>Reports </div>:""}
                {/* <div className="col-md-2 tabfour">View Request</div> */}
                </div></div></div>:''}
             {istab!==3?
             <div className="row">
             <div className="col-md-2" style={{marginRight: "-3%",marginLeft:"3%"}}>
                    <label>Select Month & Year</label>
                    </div>
                    <div className="col-md-1">
                    <select
                        name="select"
                        id="select"
                        value={monthselect}
                        onChange={(e) =>callmonth(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={monthselect === ""}
                        >
                            Month
                        </option>                        
                            <option value="01" disabled={0}>Jan</option>
                            <option value="02" disabled={0}>Feb</option>
                            <option value="03" disabled={0}>Mar</option>
                            <option value="04" disabled={0}>Apr</option>
                            <option value="05" disabled={0}>May</option>
                            <option value="06" disabled={0}>Jun</option>
                            <option value="07" disabled={0}>Jul</option>
                            <option value="08" disabled={0}>Aug</option>
                            <option value="09" disabled={0}>Sep</option>
                            <option value="10" disabled={0}>Oct</option>
                            <option value="11" disabled={0}>Nov</option>
                            <option value="12" disabled={0}>Dec</option>


                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        <div className="col-md-1">
                        <select
                        name="select"
                        id="select"
                        value={yearselect}
                        onChange={(e) =>callyear(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={yearselect === ""}
                        >
                            Year
                        </option>                        
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                       
                        {istab==1?<><div className="col-md-1">
                            <Button variant="info" 
                        onClick={() => callapprove()}
                    >
                        Approve
                    </Button>   
                        </div>
                        <div className="col-md-1">
                        <Button variant="warning"
                        onClick={() => callreject()}
                    >
                        Reject
                    </Button>   
                        </div></>:''}
                        {istab!=1?<div className="col-md-2 summary-timesheet" >
                            <p>Summary</p>
                           <span>Total Available Hours :160 </span>
                           <p>Total Worked Hours :{totalhoursworked} </p>
                        </div>:''}
                        </div>
                       :''}  
             {istab===1?
             <fieldset>
                 {/* <p>Employee Name: B.vignesh</p> */}
                 <div className="row serachdesign">
                        <div className="col-md-1"><label for="switchcode">
                        Search
                        </label></div>
                        <div className="col-md-3"><input
                            type="text"
                            name="switchcode"
                            id="switchcode"
                            value={searchdata}
                            onChange={(e) =>
                                searchfunction(e.target.value)
                            }
                            placeholder="Search"
                            required
                        /></div>
                        </div>
                <form action="#" method="get">
                <div className="">
                <div className="assettable " style={{width:'80%',marginLeft:"4%",height:"70vh",overflow:"auto"}}>
          
                <table className="table-full">
                <thead className="header-asset">
                    <tr className="textalign-tr">
                        <th><div><input id="checkboxs" className="selectedall"name="checked_box" onChange={(e)=>checkedall(e)} type="checkbox"/> Select All</div></th>
                        <th>Date</th>
                        <th>Employee ID</th>
                        <th>Employee Name</th>
                        <th>Project</th>
                        <th>Available Hours</th>
                        <th>Worked Hours</th>
                        <th>Remarks</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {
                        
                        approvallist.length ? approvallist.map((val,i)=>{
                            return(
                            
                            <tr>
                                {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                                <td className="textalign-tr"><input id="checked_box" name="chk" onChange={(e)=>checkindividual(e,val,i)} type="checkbox"/></td>
                                <td className="textalign-tr">{val.date}</td>
                                <td className="textalign-tr">{val.empid}</td>
                                <td className="textalign-tr">{val.emp_name}</td>
                                <td className="textalign-tr">{val.projectid}</td>
                                <td className="textalign-tr">8</td>
                                <td className="textalign-tr">{val.hours}</td>
                                <td className="textalign-tr">{val.remarks}</td>
                                {/* <td style={{width:"10%"}}> <img title="Approval" style={{width:"25%", cursor:"pointer"}} onClick={(e)=>approvefn(val,i)} className="" src={right}/>  <img style={{width:"22%", cursor:"pointer"}} onClick={(e)=>rejectfn(val,i)} className="" src={cross} title="Reject"/></td> */}
                                
                            </tr>
                            )
                            }) : ''
                    }
                </tbody>
                </table>
                </div>
                    </div>
                    {/* {istab===1?<div className="button-box" >
                    <div className="">  
                    <Button
                        variant="primary"
                        className="btn buttonitem1"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className="">  
                    <Button
                    variant="primary"
                      className="btn buttonitem2"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>:''} */}
                </form>
                </fieldset>:istab===3?<div><div className="row serachdesign">
                        <div className="col-md-1"><label for="switchcode">
                        Start Date
                        </label></div>
                        <div className="col-md-2">
                        <DatePicker
                        selected={startdate}
                        onChange={(date) => setStartdate(date)}
                        selectsStart
                        maxDate={new Date()}
                        // minDate={moment(new Date()).subtract(30, 'days')}
                    />    
                        {/* <input type="date"  onChange={(e) =>setStartdate(e.target.value)} id="birthday" name="from"/> */}
                        </div>
                        <div className="col-md-1"><label for="switchcode">
                        End Date
                        </label></div>
                        <div className="col-md-2" >
                        <DatePicker
                        selected={enddate}
                        onChange={(date) => setEnddate(date)}
                        selectsEnd
                        startDate={startdate}
                        endDate={enddate}
                        maxDate={new Date()}
                        
                    />
                        {/* <input type="date" max="now()"  id="birthday" name="to"/> */}
                        </div>
                        {/* <div className="col-md-2">
                        <MultiSelect value={selectedCities} onChange={(e) => setSelectedCities(e.value)} options={cities} optionLabel="name" 
                        placeholder="Select Cities" maxSelectedLabels={3} className="w-full md:w-20rem" />
                        </div> */}
                        <div className="col-md-1">
                        <Button variant="info" 
                        onClick={() => generatereport()}
                    >
                        Generate
                    </Button> 
                    </div>
                        </div>
                        
                        </div>:			   
                <fieldset>
                <form action="#" method="get">
                <div className="row">
                <div className="assettable row" style={{width:'80%',marginLeft:"4%",height:"70vh",overflow:"auto"}}>
                <table className="table-full">
                <thead className="header-asset">
                    <tr>
                        <th>Date</th>
                        <th>Projects</th>
                        <th>Available Hours</th>
                        <th>Worked Hours</th>
                        <th>Status</th>
                        <th>Remarks</th>
                        <th>Add</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {
                        
                        datearray.length ? datearray.map((val,i)=>{
                            return(
                            
                            <tr className={val.status==="Submitted" || val.status==="Approved"?'':val.isreq === true ?"":"addtime-bg"}>
                                {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                                <td className="inputcss">{val.date}</td>
                                <td className="selectcss">
                                {(val.projects!==""&&val.status==="Submitted") ||(val.projects!==""&&val.status==="Approved")?val.projects:
                                <select onChange={(e)=>onOptionChangeHandler(i,e,val)}>
                                   
                                    <option>select</option>
                                    {options.map((option, index) => {
                                        return (
                                            <option key={index}>
                                                {option}
                                            </option>
                                        );
                                    })}
                             </select>}
                                </td>
                                <td className="inputcss">8</td>
                                <td className="inputcss">
                                {(val.workedhours!==""&&val.status==="Submitted") ||(val.projects!==""&&val.status==="Approved") != false?val.workedhours: 
                                    <input
                                    id="no-paste"
                                    type="number"
                                    placeholder="Enter text"
                                    value={fields[i] || ""}
                                    onKeyDown={handleKeyDown}
                                    onpaste="return false;"
                                    onChange={(e) => handleChange(i, e,val.date)}
                                />}</td>
                                <td className="inputcss">{val.status}</td>
                                <td className="inputcss"> {(val.workedhours!==""&&val.status==="Submitted") ||(val.projects!==""&&val.status==="Approved") != false?val.remarks: 
                                    <input
                                    type="text"
                                    placeholder="Enter Remarks"
                                    value={fieldsremark[i] || ""}
                                    onChange={(e) => handleChangeremarks(i, e,val.date)}
                                />}</td>
                                {val.status==="Submitted" || val.status==="Approved"?'':val.isreq === true ?<td className="inputcss" style={{width:"10%"}}> <img style={{width:"15%", cursor:"pointer"}} onClick={(e)=>addfield(e,i)} className="" src={plus}/></td>:<td className="inputcss"style={{width:"10%"}}> <img style={{width:"15%", cursor:"pointer"}} onClick={(e)=>removefield(e,i)} className="" src={minus}/></td>}
                                
                            </tr>
                            )
                            }) : ''
                    }
                </tbody>
                </table>
                </div>
                
            </div>                   
                    
                </form>
                </fieldset>}
            </div> 
        </div>
        {istab===2?<div className="button-box" >
                    <div className="">   
                    <Button
                        variant="primary"
                        className="btns buttonitem1"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className=""> 
                    <Button
                    variant="primary"
                      className="btns buttonitem2"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>:''}
    </div>
    );
}


export default Landing;
